export var changeCourseListUserCounter = function(change){
    const counter = $("#course-list").find(".m-f-t-item.chosen .badge");
    const oldCount = parseInt(counter.html());
    const newCount = oldCount + change;
    counter.html(newCount);
  }
  
  export var resetCourseListUserCounter = function(){
    const counter = $("#course-list").find(".m-f-t-item.chosen .badge");
    counter.html(0);
  }